
export default function products() {

  $('.block-merch__content-list').owlCarousel({
    items: 3,
    dotsEach: false,
    loop: true,
    nav: true,
    smartSpeed: 1000,
    mouseDrag: false,
    navText: ['<i class="fas fa-arrow-left"></i>','<i class="fas fa-arrow-right"></i>'],
    responsive: {
      0 : {
        items: 1
      },
      480 : {
        items: 2
      },
      768 : {
        items: 3
      }
    }
  });

}
